import { render, staticRenderFns } from "./AppButtonUpload.vue?vue&type=template&id=addd04fc&scoped=true&"
import script from "./AppButtonUpload.vue?vue&type=script&lang=js&"
export * from "./AppButtonUpload.vue?vue&type=script&lang=js&"
import style0 from "./AppButtonUpload.vue?vue&type=style&index=0&id=addd04fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addd04fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
